import React from 'react';

import SidePanelContainer from 'src/views-new/sidepanel/common/SidePanelContainer';
import { SidePanelManager } from 'src/views-new/sidepanel/common/SidePanelManager';

import { useScheduleTaskPanelContentController } from './ScheduleTaskPanelContent';

type Props = {
  scheduleTaskId: string;
  showRequirements: boolean;
};

const ScheduleTaskSidePanel = ({ scheduleTaskId, showRequirements }: Props) => {
  const controller = useScheduleTaskPanelContentController({
    scheduleTaskId,
    showRequirements,
    onClose: SidePanelManager.closeSidePanel,
    onHasUnsavedNoteChangesChange: SidePanelManager.setHasUnsavedNoteChanges,
    onNoteCreated: () => SidePanelManager.setHasUnsavedNoteChanges(false),
  });

  return <SidePanelContainer>{controller.content}</SidePanelContainer>;
};

export default ScheduleTaskSidePanel;
